import { MappableModel } from './mappable-model'

export class ElectronicDocumentAcceptance extends MappableModel {
  public id: string
  public electronic_document_id: string
  public full_name_at_signing: string
  public version_number: number
  public persona_id: number
  public created_at: string
  public updated_at: string
}
